import { render, staticRenderFns } from "./add-content.vue?vue&type=template&id=35ddf120&scoped=true"
import script from "./add-content.vue?vue&type=script&lang=js"
export * from "./add-content.vue?vue&type=script&lang=js"
import style0 from "./add-content.vue?vue&type=style&index=0&id=35ddf120&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddf120",
  null
  
)

export default component.exports